import isEqual from 'lodash/isEqual';
import { Filters, FilterType } from '@domain-group/fe-allhomes-search-api';
import { RentalType } from '@domain-group/fe-allhomes-library';
var moreOptionsFilterTypes = [FilterType.availability, FilterType.listedPropertyTypes, FilterType.propertyStatus, FilterType.saleMethods, FilterType.onlyWithPrice, FilterType.blockSize, FilterType.floorArea, FilterType.listingFeatures, FilterType.keywords];
var isFilterValueEqual = function isFilterValueEqual() {
  var defaultFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var filterType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultValue = Boolean(defaultFilters.getFilterValue) && defaultFilters.getFilterValue(filterType.name) || {};
  var currentValue = Boolean(currentFilters.getFilterValue) && currentFilters.getFilterValue(filterType.name) || {};
  return isEqual(defaultValue, currentValue);
};
var filterBtr = filters => {
  if (filters.listedPropertyTypes) {
    ['default', 'selected'].forEach(key => {
      // eslint-disable-next-line no-param-reassign
      filters.listedPropertyTypes[key] = filters.listedPropertyTypes[key].filter(value => value !== RentalType.BUILD_TO_RENT.name);
    });
    // eslint-disable-next-line no-param-reassign
    filters.listedPropertyTypes.available = filters.listedPropertyTypes.available.filter(option => option.name !== RentalType.BUILD_TO_RENT.name);
  }
};
var getMoreOptionsTitle = _ref => {
  var btrEnabled = _ref.btrEnabled;
  return (currentFilters, listingType) => {
    var defaultFilters = new Filters(listingType);
    if (!btrEnabled) {
      filterBtr(defaultFilters);
      filterBtr(currentFilters);
    }
    var count = 0;
    moreOptionsFilterTypes.forEach(filterType => {
      if (!isFilterValueEqual(defaultFilters, currentFilters, filterType)) {
        count += 1;
      }
    });
    var title = count === 1 ? 'Option' : 'Options';
    var prefix = count || 'More';
    return "".concat(prefix, " ").concat(title);
  };
};
var buildMoreOptionsProps = (filters, onChange) => ({
  filters,
  onChange
});
export default buildMoreOptionsProps;
export { moreOptionsFilterTypes, getMoreOptionsTitle };